module.exports = __webpack_public_path__ + "assets/3ca04bb0c9a5fa52b2c0358ec4887b1f.mp3";